import { render } from "./signature.vue?vue&type=template&id=567a4378"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/signature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "567a4378"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('567a4378', __exports__)) {
    console.log('reload')
    api.reload('567a4378', __exports__)
  }
  
  module.hot.accept("./signature.vue?vue&type=template&id=567a4378", () => {
    console.log('re-render')
    api.rerender('567a4378', render)
  })

}


export default __exports__